const stringToSeed = str => {
  let h = 2166136261 >>> 0
  for (let i = 0; i < str.length; i++) h = Math.imul(h ^ str.charCodeAt(i), 16777619)
  return h >>> 0
}

// allows using either a number or a string as a seed and the result is a number that works well with prng, noise functions etc
export function makeSeed(seed) {
  return typeof seed === 'number' ? seed >>> 0 : stringToSeed(String(seed))
}
